import { render } from "./PhoneFrame.vue?vue&type=template&id=793fc1a7&scoped=true"
import script from "./PhoneFrame.vue?vue&type=script&lang=js"
export * from "./PhoneFrame.vue?vue&type=script&lang=js"

import "./PhoneFrame.vue?vue&type=style&index=0&id=793fc1a7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793fc1a7"]])

export default __exports__